module.exports = __webpack_public_path__ + "static/etc-logo-white-8eb9ac7ccbe8648ffad2a3b484326740.svg";